import Message from './Message/index.js'
import Wechat from './Wechat/index.js'
// import Sa from './Sa/index.js'
import {config} from '@/api'
import confirmPopup from '../components/Popup/index.js'
const wechat = new Wechat(config.wechat)
// const sa = new Sa()
const install = function (Vue) {
  Vue.prototype.$message = Message
  // Vue.prototype.$sa = sa
  Vue.use(wechat, config.wechat)
  Vue.prototype.$popup = confirmPopup
}
export default {
  install,
  wechat
}